"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    RadioGroupContext: function() {
        return RadioGroupContext;
    },
    RadioGroupProvider: function() {
        return RadioGroupProvider;
    },
    useRadioGroupContextValue_unstable: function() {
        return useRadioGroupContextValue_unstable;
    },
    useRadioGroupContext_unstable: function() {
        return useRadioGroupContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const RadioGroupContext = /*#__PURE__*/ _react.createContext(undefined);
const radioGroupContextDefaultValue = {};
const RadioGroupProvider = RadioGroupContext.Provider;
const useRadioGroupContextValue_unstable = ()=>_react.useContext(RadioGroupContext) || radioGroupContextDefaultValue;
const useRadioGroupContext_unstable = (selector)=>selector(useRadioGroupContextValue_unstable());
